import styled from 'styled-components';


 

export const Container = styled.div`

-webkit-user-select: none;  
-moz-user-select: none;    
-ms-user-select: none;    
  border-radius: var(--br-xs);
  background-color: var(--color-white);
  width: calc(21em);
  height: calc(95vh);
  margin-right: 23px;
`;

export const LogoContainer = styled.div`
  margin-top:1em;
  margin-left:2.2em; 
  display:flex;
  flex-direction:row;
  width: 100%;  
  color: var(--color-black);
  font-family: var(--font-audiowide);
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;    
`;
export const Carpad = styled.div` 
  text-transform: uppercase;
  font-size: 2em;
`;
export const Slogan = styled.div` 
  margin-top:-6px;
  margin-left:2px;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #838383;
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;    
`;
export const Logo = styled.img`  
  
  bottom: 0%;
  left: 0%;
  padding-top:5px;
  max-width: 21%;
  overflow: hidden;
  max-height: 100%;
`; 
export const SloganContainer = styled.div`  
margin-left:3px;
display:flex;
flex-direction:column;
  max-width: 100%;
  overflow: hidden;  
`; 

export const MenuContainer = styled.div`  
padding-top: 10px;
padding-left: 10px;
margin-left:3px;
display:flex;
flex-direction:column;
  max-width: 100%;
  overflow: hidden;  
`;

  
export const MenuItem = styled.div`  
margin-top:15px;
padding-top:5px;
display:flex;
flex-direction:rows; 
overflow: hidden;    
width: 90%;
height: 20px;
cursor:pointer;
`;
export const MenuIcon = styled.img`  
width: 13px;
height: 13px;
padding-left:10px;
flex-shrink: 0;
  max-width: 100%;
  overflow: hidden;  
`; 
export const MenuTitle = styled.div`  
padding-left:18px;
display:flex;
flex-direction:column;
  max-width: 100%;
  overflow: hidden;  
  font-size: 12px;
  
  color: var(--color-dimgray);
  font-family: var(--font-product-sans);
  -webkit-user-select: none;  
  -moz-user-select: none;    
  -ms-user-select: none;    
`; 

export const MenuContainerBottom = styled.div`  
position: absolute;
bottom: 0;

margin-bottom: 50px;
padding-left: 10px;
margin-left:3px;
display:flex;

flex-direction:column;
max-width: 100%;
min-width: 100%;
overflow: hidden;  
`;
